import HomeStart from "@/modules/home/HomeStart.vue";
import ListSections from "@/modules/sections/views/ListSections.vue";
import updateAbout from "@/modules/sections/views/updatePages/updateAbout.vue";
import updateEsg from "@/modules/sections/views/updatePages/updateEsg.vue";
import updateHistory from "@/modules/sections/views/updatePages/updateHistory.vue";
import updateHome from "@/modules/sections/views/updatePages/updateHome.vue";
import updateLocation from "@/modules/sections/views/updatePages/updateLocation.vue";
import updateOperations from "@/modules/sections/views/updatePages/updateOperations.vue";
import UserList from "@/modules/users/views/UserList.vue";
import ListFiles from "@/modules/filesInvestors/views/ListFiles.vue";
import ListFilesInvestors from "@/modules/filesInvestors/views/ListFilesInvestors.vue";
import ListMessages from "@/modules/contactMessages/views/ListMessages.vue";
import ListNews from "@/modules/news/views/ListNews.vue";
import NewsInvestors from "@/modules/news/views/NewsInvestors.vue";
import updateHomeCobre from "@/modules/sections/views/updatePages/updateHomeCobre.vue";
import updateContactCobre from "@/modules/sections/views/updatePages/updateContactCobre.vue";
import updateGallery from "@/modules/sections/views/updatePages/updateGallery.vue";

export default [
    {
      path: "",
      component: () =>
        import( "@/layouts/PrivateLayout.vue"),
      meta: {
        requireAuth: true,
        role: [ 'ADMIN', 'SUPERADMIN','INVESTORS'],
        area: ['FRONTERA', 'NA', 'COBRE']
      },
      children: [
        {
          path: "start",
          name: "start",
          component: HomeStart,
          meta: {
            title: "Inicio",
            role: [ 'ADMIN', 'SUPERADMIN','INVESTORS'],
            area: ['FRONTERA', 'NA', 'COBRE'],
            fullWidth: false
          },
        },
        {
          path: "list-sections",
          name: "list-sections",
          component: ListSections,
          meta: {
            title: "Lista de Secciones",
            role: [ 'ADMIN', 'SUPERADMIN'],
            area: ['FRONTERA'],
            fullWidth: false
          },
        },
        {
          path: "update-about",
          name: "update-about",
          component: updateAbout,
          meta: {
            title: "Actualizar Acerca de",
            role: [ 'ADMIN', 'SUPERADMIN'],
            area: ['FRONTERA'],
            fullWidth: false
          },
        },
        {
          path: "update-esg",
          name: "update-esg",
          component: updateEsg,
          meta: {
            title: "Actualizar ESG",
            role: [ 'ADMIN', 'SUPERADMIN'],
            area: ['FRONTERA'],
            fullWidth: false
          },
        },
        {
          path: "update-history",
          name: "update-history",
          component: updateHistory,
          meta: {
            title: "Actualizar Historia",
            role: [ 'ADMIN', 'SUPERADMIN'],
            area: ['FRONTERA'],
            fullWidth: false
          },
        },
        {
          path: "update-contact-cobre",
          name: "update-contact-cobre",
          component: updateContactCobre,
          meta: {
            title: "Actualizar Contacto",
            role: [ 'ADMIN', 'SUPERADMIN'],
            area: ['COBRE'],
            fullWidth: false
          },
        },
        {
          path: "update-home",
          name: "update-home",
          component: updateHome,
          meta: {
            title: "Actualizar Inicio",
            role: [ 'ADMIN', 'SUPERADMIN'],
            area: ['FRONTERA'],
            fullWidth: false
          },
        },
        {
          path: "update-location",
          name: "update-location",
          component: updateLocation,
          meta: {
            title: "Actualizar Ubicación",
            role: [ 'ADMIN', 'SUPERADMIN'],
            area: ['FRONTERA'],
            fullWidth: false
          },
        },
        {
          path: "update-operations",
          name: "update-operations",
          component: updateOperations,
          meta: {
            title: "Actualizar Operaciones",
            role: [ 'ADMIN', 'SUPERADMIN'],
            area: ['FRONTERA'],
            fullWidth: false
          },
        },
        {
          path: "update-home-cobre",
          name: "update-home-cobre",
          component: updateHomeCobre,
          meta: {
            title: "Actualizar Inicio",
            role: [ 'ADMIN', 'SUPERADMIN'],
            area: ['COBRE'],
            fullWidth: false
          },
        },
        {
          path: "update-gallery",
          name: "update-gallery",
          component: updateGallery,
          meta: {
            title: "Actualizar Galería",
            role: [ 'ADMIN', 'SUPERADMIN'],
            area: ['FRONTERA', 'COBRE'],
            fullWidth: false
          },
        },
        {
          path: "user-list",
          name: "user-list",
          component: UserList,
          meta: {
            title: "Lista de Usuarios",
            role: [ 'SUPERADMIN'],
            area: ['FRONTERA', 'COBRE'],
            fullWidth: false
          },
        },
        {
          path: "list-files",
          name: "list-files",
          component: ListFiles,
          meta: {
            title: "Lista de Archivos",
            role: [ 'ADMIN', 'SUPERADMIN'],
            area: ['FRONTERA', 'COBRE'],
            fullWidth: false
          },
        },
        {
          path: "list-files-investors",
          name: "list-files-investors",
          component: ListFilesInvestors,
          meta: {
            title: "Lista de Archivos",
            role: [ 'ADMIN', 'SUPERADMIN', 'INVESTORS'],
            area: ['FRONTERA', 'COBRE', 'NA'],
            fullWidth: true
          },
        },
        {
          path: "list-messages",
          name: "list-messages",
          component: ListMessages,
          meta: {
            title: "Lista de mensajes para contacto",
            role: [ 'ADMIN', 'SUPERADMIN'],
            area: ['COBRE'],
            fullWidth: false
          },
        },
        {
          path: "list-news",
          name: "list-news",
          component: ListNews,
          meta: {
            title: "Lista de Noticias",
            role: [ 'ADMIN', 'SUPERADMIN'],
            area: ['FRONTERA', 'COBRE'],
            fullWidth: false
          },
        },
        {
          path: "news-investors",
          name: "news-investors",
          component: NewsInvestors,
          meta: {
            title: "Noticias",
            role: [ 'ADMIN', 'SUPERADMIN', 'INVESTORS'],
            area: ['FRONTERA', 'COBRE', 'NA'],
            fullWidth: true
          },
        }
      ],
    },
  ];